<div>
  <app-main-loader-lottie screenPosition="relativeScreen"></app-main-loader-lottie>
</div>
